import {
  loading,
  loadingLoader,
  loadingOverlay,
} from '@mage-ui/styled-system/recipes';
import { LoadingOverlay } from '@mantine/core';
import { Loader } from '../../data-display/loader/Loader';

export const Loading = ({ visible, texts, classNames, ...props }) => {
  return (
    <LoadingOverlay
      visible={visible}
      loaderProps={{ children: <Loader texts={texts} /> }}
      classNames={{
        root: loading(),
        loader: loadingLoader(),
        overlay: loadingOverlay(),
      }}
      {...props}
    />
  );
};
